/**
 * Extracts a human-readable error message from various error shapes.
 * Returns a generic fallback message when the error structure is unknown.
 */
export function getFetchErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') {
    return 'Could not load capsules.';
  }

  const errorRecord = error as Record<string, unknown>;
  const dataField = errorRecord.data;
  if (typeof dataField === 'string') {
    return dataField;
  }

  const errorField = errorRecord.error;
  if (typeof errorField === 'string') {
    return errorField;
  }

  return 'Could not load capsules.';
}
